import { CloseCircleOutlined, InfoCircleOutlined, WarningOutlined } from "@ant-design/icons";
import type { ModalProps } from "antd";
import { Button, Modal, Space } from "antd";
import React from "react";

export type NotificationType = "info" | "warning" | "error";

export interface ModalNotificationProps extends Omit<ModalProps, "open"> {
  open?: boolean;
  type?: NotificationType;
  title?: string;
  message?: string | React.ReactNode;
  onOk?: () => void;
  onCancel?: () => void;
  okText?: string;
  cancelText?: string;
  showCancel?: boolean;
}

const ModalNotification: React.FC<ModalNotificationProps> = ({
  open = false,
  type = "info",
  title,
  message,
  onOk,
  onCancel,
  okText = "Xác nhận",
  cancelText = "Đóng",
  showCancel = true,
  ...restProps
}) => {
  const getIcon = () => {
    const baseStyle: React.CSSProperties = { fontSize: 24, marginRight: 12 };
    const iconProps = { style: baseStyle } as React.ComponentProps<typeof InfoCircleOutlined>;
    switch (type) {
      case "info":
        return <InfoCircleOutlined {...iconProps} style={{ ...baseStyle, color: "#1890ff" }} />;
      case "warning":
        return <WarningOutlined {...iconProps} style={{ ...baseStyle, color: "#faad14" }} />;
      case "error":
        return <CloseCircleOutlined {...iconProps} style={{ ...baseStyle, color: "#ff4d4f" }} />;
      default:
        return <InfoCircleOutlined {...iconProps} style={{ ...baseStyle, color: "#1890ff" }} />;
    }
  };

  const handleOk = () => {
    if (onOk) {
      onOk();
    } else if (onCancel) {
      onCancel();
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      footer={
        <Space>
          {showCancel && (
            <Button onClick={handleCancel} {...(type === "error" ? { danger: true } : {})}>
              {cancelText}
            </Button>
          )}
          <Button type="primary" onClick={handleOk}>
            {okText}
          </Button>
        </Space>
      }
      {...restProps}
    >
      <div style={{ display: "flex", alignItems: "flex-start", padding: "8px 0" }}>
        {getIcon()}
        <div style={{ flex: 1 }}>
          {title && <h3 style={{ margin: "0 0 8px 0", fontSize: 16, fontWeight: 600 }}>{title}</h3>}
          {message && <div style={{ fontSize: 14, color: "rgba(0, 0, 0, 0.85)", lineHeight: 1.5 }}>{message}</div>}
        </div>
      </div>
    </Modal>
  );
};

export default ModalNotification;
